import { Department } from '../../../../entities/Department/Department'
import { DepartmentOption } from '../../../../types/selectOptionTypes'

export const removeDepartmentOptionsByGroupId = (departments: Department[], selectedDepartments: DepartmentOption[], groupId: string): DepartmentOption[] => {
    const removedDepartments = departments.filter(department => department.departmentGroup?.id === groupId)

    return selectedDepartments.filter(department => ! removedDepartments.map(removedDepartment => removedDepartment.id).includes(department.value))
}
